import throttle from 'lodash.throttle';
import { CustomElement } from '@/utils';

export default class Height extends CustomElement {
  static component = 'b-height';
  height = 0;
  targetSelector: string | null = null;
  target: HTMLElement | null = this;
  source: any | null = null;
  variable = '--height';
  resizeObserver: ResizeObserver;

  init() {
    this.targetSelector = this.getAttribute('target') || null;
    this.variable = `--${this.getAttribute('variable') ?? 'height'}`;
    this.source = this.$('source') || this;

    if (this.targetSelector) {
      this.target = document.querySelector(this.targetSelector);
    }

    if (this.source.getAttribute('data-clamp-trigger') !== null) {
      this.source.addEventListener('click', () => {
        this.toggleAttr('clamp', 'off');
      });
    }

    requestAnimationFrame(() => {
      this.getHeight();
      this.resizeObserver = new ResizeObserver(this.throttled.bind(this));
      this.resizeObserver.observe(this.source, {
        box: 'border-box',
      });
    })
  }

  isTextClamped() {
    return this.source.scrollHeight > this.source.clientHeight;
  }

  getHeight() {
    this.height = this.source.getBoundingClientRect().height;
    if (this.height && this.target) {
      this.target.style.setProperty(this.variable, `${this.height}px`);

      if (this.isTextClamped()) {
        this.setAttribute('clamped', '');
      } else {
        this.removeAttribute('clamped');
      }
    }
  }

  throttled = throttle(this.getHeight.bind(this), 500, { leading: true });

  destroyed() {
    this.resizeObserver.disconnect();
  }
}
